import { PropTypes } from "prop-types";
import { StyledField } from "../../../styles/StyledField";
import { Select } from "../../Select";
import { useEffect, useRef, useState } from "react";
import { StyledDirectionForm } from "../../../styles/StyledDecision/StyledContent";
import { StyledModalFooterActions } from "../../../styles/StyledAddUpperDecision";
import { Button } from "../../Button";
import AddIcon from "../../../assets/img/icons/add.svg";
import { Col, Row } from "react-grid-system";
import { Search } from "../../Search";
import { useQuery } from "react-query";
import { getAvailableDecisions } from "../../../api/decision/directions";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { SelectableSingleDecision } from "../../SelectableLists/SelectableDecisions";

export default function AddMeetingPoint({ meetingPointsData, editedMeetingPoints, updateMeetingPoints, editedId, closeModal }) {
	const { axiosPrivate } = useAxiosPrivate();

	const [editSet, setEditSet] = useState(false);
	const [order, setOrder] = useState((meetingPointsData.length + 1).toString());
	const orderRef = useRef();

	const [phrase, setPhrase] = useState("");
	const { isLoading, isError, error, data } = useQuery(["responsibility", phrase], () => {
		return getAvailableDecisions(axiosPrivate, phrase);
	});

	const [title, setTitle] = useState("");
	const [details, setDetails] = useState("");
	const [decision, setDecision] = useState();
	const [minutes, setMinutes] = useState();

	useEffect(() => {
		if (isError) console.log(error);
		if (editedId && !editSet) {
			let tempOrder;

			const temp = editedMeetingPoints.filter((e, i) => {
				if (i === parseInt(editedId)) tempOrder = i + 1;
				return i === parseInt(editedId);
			});
			const editedMeetingPoint = temp[0];

			setOrder(tempOrder);
			setTitle(editedMeetingPoint.title);
			setDetails(editedMeetingPoint.details);
			setMinutes(editedMeetingPoint?.minutes);
			if (editedMeetingPoint?.decision?.id) setDecision(editedMeetingPoint.decision.id.toString());

			setEditSet(true);
		}
	}, [meetingPointsData, editedId]);

	const handleUpdate = () => {
		const resultMeetingPoint = { title: title, details: details, decision: decision ? decision : null, minutes: minutes };
		let res;

		if (!editedId) {
			res = [...editedMeetingPoints];
			res.splice(parseInt(orderRef.current.props.value.value) - 1, 0, resultMeetingPoint);
		} else {
			res = [];
			let oldIndex;
			editedMeetingPoints.map((e, i) => {
				if (parseInt(i) === parseInt(editedId)) {
					oldIndex = i;
					res.push(resultMeetingPoint);
				} else {
					res.push(e);
				}
			});

			arrayMove(res, oldIndex, parseInt(orderRef.current.props.value.value) - 1);
		}
		updateMeetingPoints(res);
	};

	return (
		<StyledDirectionForm>
			<div className="default-fields">
				<StyledField edit={true}>
					<label>Order</label>
					<Select
						options={[
							...meetingPointsData.map((el, i) => {
								return { value: i + 1, label: i + 1 };
							}),
							{ value: meetingPointsData.length + 1, label: meetingPointsData.length + 1 },
						]}
						value={order}
						onChange={setOrder}
						id="unit"
						name="unit"
						meetingPointsData-testid="unit"
						ref={orderRef}
					/>
				</StyledField>
				<StyledField edit={true}>
					<label>Title</label>
					<input type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
				</StyledField>
			</div>
			<Row>
				<Col sm={12}>
					<StyledField edit={true}>
						<label>Details</label>
						<textarea value={details} onChange={(e) => setDetails(e.target.value)} />
					</StyledField>
				</Col>
			</Row>
			<div className="decision-fields">
				<label>Related decision</label>
				<Search isWhite setPhrase={setPhrase} value={phrase} />
				<SelectableSingleDecision data={data} isLoading={isLoading} isError={isError} error={error} setSelectedDecisionID={setDecision} />
			</div>
			<StyledModalFooterActions>
				<Button onClick={() => closeModal()} bg={false} small={true}>
					Cancel
				</Button>
				<Button icon={AddIcon} onClick={handleUpdate}>
					Confirm
				</Button>
			</StyledModalFooterActions>
		</StyledDirectionForm>
	);
}

AddMeetingPoint.propTypes = {
	editedMeetingPoints: PropTypes.any,
	updateMeetingPoints: PropTypes.any,
	meetingPointsData: PropTypes.any,
	editedId: PropTypes.string,
	closeModal: PropTypes.func,
};

function arrayMove(arr, old_index, new_index) {
	if (new_index >= arr.length) {
		let k = new_index - arr.length + 1;
		while (k--) {
			arr.push(undefined);
		}
	}
	arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
}
